module.exports = __webpack_public_path__ + "img/wzf_71.e0240c02.png";